<template>
	<div>
		<router-link :to="{ name: 'users' }">
			<span class="fa fa-long-arrow-alt-left" />
			Return to users
		</router-link>

		<h1 class="mt-1 mb-1">{{ user.fullname }}</h1>
		<h6 class="text-muted mb-4">
			Email: {{ user.email }}
		</h6>
		<h6 class="text-muted mb-4">
			Verified: {{ user.verified ? 'Yes' : 'No' }}
		</h6>
		<h6 class="text-muted mb-4">
			{{ user.banned ? 'Banned' : 'Active' }}
		</h6>
		<h6 class="text-muted mb-4">
			Phone: {{ user.phone || 'N/A' }}
		</h6>
		<h6 class="text-muted mb-4">
			Address: {{ user.residency || 'N/A' }}
		</h6>

		<h2 class="mt-5">
			Change User Password
		</h2>
		<form class="mt-4" @submit.prevent="saveUser">
			<div class="form-group">
				<label for="password">
					<small class="text-muted">NEW PASSWORD</small>
				</label>
				<input type="password" class="form-control" name="password" placeholder="Password" v-model="password"
					required autofocus />
			</div>
			<div class="form-group">
				<label for="password_confirmation">
					<small class="text-muted">CONFIRM PASSWORD</small>
				</label>
				<input type="password" class="form-control" name="password_confirmation"
					placeholder="Password confirmation" v-model="password_confirmation" required autofocus />
			</div>
			<button type="submit" class="btn btn-primary ld-ext-right mt-3" :disabled="loading"
				:class="{ running: loading }">
				{{ loading ? "Saving…" : "Save" }}
				<div class="ld ld-ring ld-spin" />
			</button>
		</form>
	</div>
</template>

<script>
import store from '../../../store';
import { mapGetters } from 'vuex';

export default {
	computed: {
		...mapGetters({
			getUserById: 'users/getById',
		}),

		user() {
			return this.getUserById(parseInt(this.$route.params.id));
		},
	},

	async beforeRouteEnter(to, from, next) {
		await store.dispatch('users/fetch', { userId: parseInt(to.params.id) });
		next();
	},

	methods: {
		saveUser() {
			this.loading = true;

			return this.$store
				.dispatch("users/update", {
					user_id: parseInt(this.$route.params.id),
					password: this.password,
					password_confirmation: this.password_confirmation,
				})
				.then(() => {
					this.$router.push({ name: "users" });
				})
				.catch(e => {
					this.error = getError(e);
					this.loading = false;
				});
		},
	},

	meta: {
		title: 'View a user',

		meta: [
			{ property: 'og:title', content: 'View a user / Al-Shayah' },
		],
	},
}
</script>